import { HostBinding, QueryList, HostListener, ElementRef, ViewChild, Component, ViewEncapsulation, OnInit, OnDestroy, SimpleChanges, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { HomeService } from '../../services/home.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MessageService } from '../../message.service';
import { AppSettings } from '../../settings';
import { BaseComponent } from '../base/base.component';
import { NewsletterService } from '../../services/newsletter.service';
import { UserService } from '../../services/user.service';
import { ArticleService } from '../../services/article.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
// import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { EditorZoom } from '../../dashboard/modals/editorzoom/editorzoom';
import { IRule } from '../../irule';
import { CommonService } from '../../services/common.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';




declare var $: any;
import * as moment from 'moment';
let date = moment().format('MMM Do,YYYY');



@Component({
  selector: 'app-create-article',
  templateUrl: './create-article.component.html',
  styleUrls: ['./create-article.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateArticleComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, IRule {




  fileUrl: any = '';

  mySize_th: number = 420;
  aspectRatio_th: number = 1;
  cropperMinWidth_th: number = 420;
  imageChangedEvent_th: any = '';
  croppedImage_th: any = '';

  mySize: number = 1224;
  aspectRatio: number = 4;
  cropperMinWidth: number = 1224;
  imageChangedEvent: any = '';
  croppedImage: any = '';

  departmentList: any = []

  classval: any = 'modal fade addnew-popup invite_popup'


  @HostBinding('style.width') public width: string = '100%';

  @ViewChild('er', { static: true }) imageCropper: any;
  @ViewChild('eth', { static: true }) imageCropper_th: any;





  textstatus: string = '';

  selectedPendingStatus: string = '';

  loginUser: any;

  permissions: any = [];

  can_edit: boolean = false;



  publishers: any = [];
  authors: any = [];
  delegates: any = [];

  comment: string = '';
  searchTxt: any = '';
  articleRecord: any;

  thumb_img: any = '';

  main_img: any = '';

  userName = '';

  navigationsType = [];


  reviewers: any = [];
  list_emails: any = [];
  approvers_id: any = [];
  publishers_id: any = [];
  shares_id: any = [];
  delegates_id: any = [];



  dropdownList = [];
  selectedItems = [];
  selectedItems2 = [];
  dropdownSettings = {};
  dropdownSettings2 = {};
  dropdownSettings3 = {};
  max_count: number = 750;
  min_count: number = 100;
  newsletterId: any;

  url: any = AppSettings.API_ENDPOINT
  fileUploadUrl: any = AppSettings.FILE_UPLOADERPATH;
  headerImage: any = '';
  headerImageName: any;
  thumbImage: any = '';
  thumbImageName: any;
  attachment: Array<any> = [];
  attachmentName: Array<any> = [];
  toltipName: Array<any> = []

  attachmentGoTO: Array<any> = [];
  attachmentNameGoTo: Array<any> = [];
  toltipNameGoTo: Array<any> = []
  totalFiles: number;
  tittle: string = '';
  subTittle: string = '';
  selectedCategoryList: Array<any> = [];
  selectedCategoryType: any;
  htmlContent: any = '';
  prevhtmlContent: any = ''
  htmlDescription: string = '';
  selectedNewsletter: Array<any> = [];


  tags: Array<string> = [];

  create_tag: string = '';

  articleCaregoryList: Array<any> = [];
  articleCaregoryType: Array<any> = [];
  newsletterList: Array<any> = []

  titleError: string
  categoryError: string;
  categoryTypeError: string;
  mainImageError: string;
  thumImageError: string;
  newsletterError: string;
  shortDescriptionError: string;
  longDescriptionError: string;
  departmentError: string;
  msgSubscription: Subscription;
  user: string;
  date: string = date;
  fileUploadType: number;

  notification: any = [];
  checkedval: boolean = false;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    toolbarPosition: 'top',
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };
  toastr: any;

  articleId: any;

  text: any = 'Create Article';

  msg: any;

  _router: any;

  commonService: any;

  token: any = '';
  isEditTag: boolean = false
  checkedExternal: boolean = false;
  department: any
  copyArticleId: any;

  countryList = [];
  country = [
    { key: 'Australia', value: 'Australia' },
    { key: 'Austria', value: 'Austria' },
    { key: 'Bahrain', value: 'Bahrain' },
    { key: 'Belgium', value: 'Belgium' },
    { key: 'Bosnia & Herzegovina', value: 'Bosnia & Herzegovina' },
    { key: 'Bulgaria', value: 'Bulgaria' },
    { key: 'Canada', value: 'Canada' },
    { key: 'Croatia', value: 'Croatia' },
    { key: 'Cyprus', value: 'Cyprus' },
    { key: 'Czech Republic', value: 'Czech Republic' },
    { key: 'Denmark', value: 'Denmark' },
    { key: 'Estonia', value: 'Estonia' },
    { key: 'Finland', value: 'Finland' },
    { key: 'France', value: 'France' },
    { key: 'Germany', value: 'Germany' },
    { key: 'Greece', value: 'Greece' },
    { key: 'Hungary', value: 'Hungary' },
    { key: 'Iceland', value: 'Iceland' },
    { key: 'India', value: 'India' },
    { key: 'Ireland', value: 'Ireland' },
    { key: 'Israel', value: 'Israel' },
    { key: 'Italy', value: 'Italy' },
    { key: 'Japan', value: 'Japan' },
    { key: 'Latvia', value: 'Latvia' },
    { key: 'Lithuania', value: 'Lithuania' },
    { key: 'Luxembourg', value: 'Luxembourg' },
    { key: 'Macedonia', value: 'Macedonia' },
    { key: 'Malaysia', value: 'Malaysia' },
    { key: 'Malta', value: 'Malta' },
    { key: 'Moldova', value: 'Moldova' },
    { key: 'Netherlands', value: 'Netherlands' },
    { key: 'New Zealand', value: 'New Zealand' },
    { key: 'Norway', value: 'Norway' },
    { key: 'Palestine', value: 'Palestine' },
    { key: 'Phillipines', value: 'Phillipines' },
    { key: 'Poland', value: 'Poland' },
    { key: 'Portugal', value: 'Portugal' },
    { key: 'Qatar', value: 'Qatar' },
    { key: 'Montenegro', value: 'Montenegro' },
    { key: 'Serbia', value: 'Serbia' },
    { key: 'Romania', value: 'Romania' },
    { key: 'Russia', value: 'Russia' },
    { key: 'Saudi Arabia', value: 'Saudi Arabia' },
    { key: 'Slovakia', value: 'Slovakia' },
    { key: 'Slovenia', value: 'Slovenia' },
    { key: 'South Africa', value: 'South Africa' },
    { key: 'Spain', value: 'Spain' },
    { key: 'Sweden', value: 'Sweden' },
    { key: 'Switzerland', value: 'Switzerland' },
    { key: 'Thailand', value: 'Thailand' },
    { key: 'Turkey', value: 'Turkey' },
    { key: 'Ukraine', value: 'Ukraine' },
    { key: 'United Arab Erimates', value: 'United Arab Erimates' },
    { key: 'United Kingdom', value: 'UK' },
    { key: 'United States of America', value: 'United States of America' }

  ];

  selectedCountry = [];
  init: any;
  init2: any;
  countryGroup: any = []

  @HostListener('window:message', ['$event'])

  onWindowMessage($event) {
    //alert(this.fileUploadType);



    console.log("message event=====", $event.data);

    //try{
    // let res:any = reader.result;
    let token: any = JSON.parse(atob(localStorage.getItem('token')));
    var data = new FormData();
    data.append('upload[0][url]', $event.data);

    // this.newsService.getFileDetails($event.data).subscribe( (res) =>{
    //   console.log("res received====",res);

    // })

    // let obj={
    //   token:token,
    //   reqData:data
    // }

    //this.newsService.imageUpload(obj).subscribe( (res) =>{
    //if(res.status=='success'){
    if (this.fileUploadType == 3) {

      if ($event.data.mime.includes("pdf") || $event.data.mime.includes("docx") || $event.data.mime.includes("xlsx") || $event.data.mime.includes("xls") || $event.data.mime.includes("csv") || $event.data.mime.includes("ppt") || $event.data.mime.includes("pptx") || $event.data.mime.includes("sheet") || $event.data.mime.includes("document") || $event.data.mime.includes("msword")) {
        if ($event.data.title.includes(".pdf") || $event.data.title.includes(".doc") || $event.data.title.includes(".docx") || $event.data.title.includes(".xlsx") || $event.data.title.includes(".xls") || $event.data.title.includes(".csv") || $event.data.title.includes(".ppt") || $event.data.title.includes(".pptx") || $event.data.title.includes(".sheet") || $event.data.title.includes(".document") || $event.data.title.includes(".msword")) {
          this.attachmentNameGoTo.push(decodeURIComponent($event.data.title))
        } else {
          this.attachmentNameGoTo.push(decodeURIComponent($event.data.title + $event.data.extn))
        }


        this.attachmentGoTO.push($event.data.url)
        let toltip = $event.data.title;
        //toltip.shift();
        //  let arr=[]
        //  toltip.map((y)=>{
        //    arr.push(decodeURIComponent(y))
        //  })
        this.toltipNameGoTo.push(decodeURIComponent($event.data.title))
      } else {
        this.toastr.error('Please attach a file of the supported types!', '', { timeOut: 3000 });
      }


    }
    if (this.fileUploadType == 2) {
      if ($event.data.mime.includes('image')) {
        var convertToKB = ($event.data.size / 1024);
        var convertToMb = (convertToKB / 1024);
        // var convertToMb = 5;

        if (convertToMb < 10) {
          if ($event.data.dimension.width > 420 && $event.data.dimension.height > 420) {
            this.thumbImage = $event.data.url;
            this.thumbImageName = $event.data.title;
            this.thumImageError = '';
          } else {
            this.toastr.error('Please upload a file within the mentioned file resolution!', '', { timeOut: 3000 });
          }
        } else {
          this.toastr.error('Please upload a file within the mentioned file size limit!', '', { timeOut: 3000 });
        }

      } else {
        this.toastr.error('Please attach a file of the supported types!', '', { timeOut: 3000 });
      }
    }

    if (this.fileUploadType == 1) {
      if ($event.data.mime.includes('image')) {

        var convertToKB = ($event.data.size / 1024);
        var convertToMb = (convertToKB / 1024);
        //var convertToMb = 5;
        if (convertToMb < 10) {
          if ($event.data.dimension.width > 1224 && $event.data.dimension.height > 306) {
            this.headerImage = $event.data.url;
            this.headerImageName = $event.data.title;
            //this.thumImageError='';
          } else {
            this.toastr.error('Please upload a file within the mentioned file resolution!', '', { timeOut: 3000 });
          }
        } else {
          this.toastr.error('Please upload a file within the mentioned file size limit!', '', { timeOut: 3000 });
        }

      } else {
        this.toastr.error('Please attach a file of the supported types!', '', { timeOut: 3000 });
      }
    }


    //}
    //})
    // }
    // catch(e){
    //   this.toastr.error('File upload failed!', '', {timeOut: 3000});
    // }
  }

  constructor(private userService: UserService, private domSanitizer: DomSanitizer,
    private cmmonService: CommonService, private route: ActivatedRoute, private modalService: NgbModal, msg: MessageService, toastr: ToastrService, homeservice: HomeService, _router: Router, private newsService: NewsletterService, private articleService: ArticleService) {

    super(msg, toastr, homeservice, _router);

    this.toastr = toastr;

    this.msg = msg;

    this._router = _router;

    this.commonService = cmmonService;



    this.route.queryParams.subscribe(params => {
      if (params.newsletter != undefined) {
        this.newsletterId = params.newsletter;
      }
    })


    try {

      let tokenA: any = (localStorage.getItem('token') != undefined) ? atob(localStorage.getItem('token')) : 0;

      if (!tokenA) throw 'Error in parse';

      if (!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);

      this.token = tokenA.token;

      let data = {
        token: tokenA.token,

      }

      this.articleService.getCategoryList(data).subscribe((result) => {

        this.userName = result.user.name;

        this.loginUser = result.user;

        this.navigationsType = result.navigation;

        this.notification = result.notification;

        this.broadcast_menu(); //for left menu



        if (result.status == 'success') {

          result.category.map((x) => {
            let string = x.value
            x.value = string.charAt(0).toUpperCase() + string.slice(1)
          })

          this.articleCaregoryList = result.category

          this.articleService.getCategoryType(data).subscribe((res) => {

            if (res.status == 'success') {

              this.articleCaregoryType = res.type;

              this.newsService.newsletterData(data).subscribe((response) => {

                let list = []

                if (response.status == 'success') {

                  if (response.newsletter != undefined) {
                    response.newsletter.map((x) => {
                      let data = {}
                      data['key'] = x.id;
                      data['value'] = x.templateName;

                      list.push(data)
                    })

                    this.newsletterList = list;

                    let news = []

                    if (this.newsletterId) {
                      let id = this.newsletterId
                      this.newsletterList.map((x) => {
                        if (x.key == id) {
                          news.push(x)
                        }
                      })
                    }

                    this.selectedNewsletter = news;
                  }



                  this.articleId = +this.route.snapshot.paramMap.get('id');

                  if (this.articleId) {


                    this.text = 'Edit Article'

                    let data2 = {
                      token: tokenA.token,
                      id: this.articleId,
                      'page': 'article'
                    }

                    this.articleService.articleData(data2).subscribe((response) => {

                      if (response.status == 'success') {

                        this.articleRecord = response.article[0];


                        console.log("articel details====", this.articleRecord.document);



                        this.loginUser = response.user;

                        this.permissions = (response.permission != undefined || response.permission != null) ? response.permission : [];

                        this.can_edit = (this.check_permission_admin(this.articleRecord, this.loginUser) || this.check_permission_publisher(this.articleRecord, this.loginUser) || this.check_permission_author(this.articleRecord, this.loginUser) || this.check_permission_reviewer(this.articleRecord, this.loginUser) || this.check_permission_coauthor(this.articleRecord, this.loginUser));


                        // console.log(this.can_edit);


                        if (!this.can_edit) {

                          toastr.error(' You dont have the permission to edit the article  !', '', { timeOut: 3000 });

                          this._router.navigate(['/article']);


                        }




                        this.tittle = response.article[0].title;
                        let news = []
                        if (response.article[0].newsletter != null || response.article[0].newsletter != undefined) {
                          this.newsletterList.map((x) => {
                            if (x.key == response.article[0].newsletter.id) {
                              news.push(x)
                            }
                          })
                        }

                        this.selectedNewsletter = news

                        $('.article_title').addClass('value-exists');

                        this.subTittle = response.article[0].subtitle;

                        $('.article_subtitle').addClass('value-exists');




                        this.htmlDescription = response.article[0].summary;

                        this.htmlContent = response.article[0].content;

                        this.prevhtmlContent = this.domSanitizer.bypassSecurityTrustHtml(response.article[0].content);

                        let categoryarr = []
                        response.article[0].category.map((x) => {


                          let value = this.get_category_type(x)
                          if (value != '') {
                            let string = value
                            let json = {
                              "key": x,
                              "value": string.charAt(0).toUpperCase() + string.slice(1)
                            }
                            categoryarr.push(json)
                          }

                        })


                        this.selectedCategoryList = categoryarr;

                        let type = response.article[0].type.split('_').join(" ")

                        type = this.titleCaseType(response.article[0].type)

                        let json = [{
                          "key": response.article[0].type,
                          "value": type.charAt(0).toUpperCase() + type.slice(1)
                        }]

                        this.selectedCategoryType = json

                        console.log("articel====", response.article[0]);

                        let name = (response.article[0].mainimage != undefined && response.article[0].mainimage != '') ? response.article[0].mainimage.split('/') : [];
                        let tname = (response.article[0].thumbimage != undefined && response.article[0].thumbimage != '') ? response.article[0].thumbimage.split('/') : [];
                        this.headerImage = response.article[0].mainimage;


                        this.headerImageName = (name.length > 0) ? name[2] : '';

                        if (this.headerImage && this.headerImage.includes("mitsubishi-motors")) {
                          try {

                            let token: any = JSON.parse(atob(localStorage.getItem('token')));
                            var data = new FormData();
                            data.append('upload[0][url]', this.headerImage);

                            let obj = {
                              token: token,
                              reqData: data
                            }

                            this.newsService.imageUpload(obj).subscribe((res) => {
                              if (res.status == 'success') {
                                console.log("filename===", res.files[0].info['Content-Disposition']['filename']);

                                this.headerImageName = decodeURIComponent(res.files[0].info['Content-Disposition']['filename'])

                              }

                            })
                          }
                          catch (e) {
                            this.toastr.error('File upload failed!', '', { timeOut: 3000 });
                          }
                        }




                        this.thumbImage = response.article[0].thumbimage;
                        this.thumbImageName = (tname.length > 0) ? tname[2] : '';

                        if (this.thumbImage && this.thumbImage.includes("mitsubishi-motors")) {
                          try {

                            let token: any = JSON.parse(atob(localStorage.getItem('token')));
                            var data = new FormData();
                            data.append('upload[0][url]', this.thumbImage);

                            let obj = {
                              token: token,
                              reqData: data
                            }

                            this.newsService.imageUpload(obj).subscribe((res) => {
                              if (res.status == 'success') {
                                console.log("filename===", res.files[0].info['Content-Disposition']['filename']);

                                this.thumbImageName = decodeURIComponent(res.files[0].info['Content-Disposition']['filename'])

                              }

                            })
                          }
                          catch (e) {
                            this.toastr.error('File upload failed!', '', { timeOut: 3000 });
                          }
                        }



                        response.article[0].document.map((x) => {
                          console.log("x=====", x);

                          if (x.includes("mitsubishi-motors")) {
                            try {

                              let token: any = JSON.parse(atob(localStorage.getItem('token')));
                              var data = new FormData();
                              data.append('upload[0][url]', x);

                              let obj = {
                                token: token,
                                reqData: data
                              }

                              this.newsService.imageUpload(obj).subscribe((res) => {
                                if (res.status == 'success') {
                                  console.log("filename===", res.files[0].info['Content-Disposition']['filename']);

                                  this.attachmentNameGoTo.push(decodeURIComponent(res.files[0].info['Content-Disposition']['filename']))
                                  this.attachmentGoTO.push(x)
                                  //  let toltip = res.files[0].info['Content-Disposition']['filename'];
                                  //  toltip.shift();
                                  //  let arr=[]
                                  //  toltip.map((y)=>{
                                  //    arr.push(decodeURIComponent(y))
                                  //  })
                                  this.toltipNameGoTo.push(decodeURIComponent(res.files[0].info['Content-Disposition']['filename']))
                                  this.totalFiles = this.attachment.length + this.attachmentGoTO.length;

                                }

                              })
                            }
                            catch (e) {
                              this.toastr.error('File upload failed!', '', { timeOut: 3000 });
                            }
                          } else {
                            let name = x.split('/');
                            this.attachmentName.push(name[2])
                            this.attachment.push(x)
                            let toltip = name[2].split('_');
                            toltip.shift();
                            let arr = []

                            toltip.map((y) => {
                              arr.push(y)
                            })

                            this.toltipName.push(arr.join('_'))
                            this.totalFiles = this.attachment.length;
                          }

                        })
                        console.log("f1===", this.attachment.length);
                        console.log("f2===", this.attachmentGoTO);

                        let tags = []
                        response.article[0].tag.map((x) => {
                          let data = {}
                          data['name'] = x
                          data['isEdit'] = false
                          tags.push(data)
                        })

                        this.tags = response.article[0].tag;
                        if (response.article[0].department != undefined) {
                          this.department = response.article[0].department
                        }

                        if (response.article[0].country != undefined) {
                          let country = []
                          response.article[0].country.map((x) => {
                            let obj = {}
                            obj['key'] = x.toUpperCase()
                            obj['value'] = x
                            country.push(obj)
                          })
                          this.selectedCountry = country
                        }



                        // this.tags = tags

                        // this.date = moment(response.article[0].history.createdDate,'MMM Do,YYYY').format('MMM Do,YYYY');

                        this.date = response.article[0].history.createdDate;

                        if (response.article[0].private == 1) {
                          this.checkedval = true;
                        } else {
                          this.checkedval = false;
                        }

                        if (response.article[0].external == 1) {
                          this.checkedExternal = true;
                        } else {
                          this.checkedExternal = false;
                        }


                      } else {

                        toastr.error('Article Not Found  !', '', { timeOut: 3000 });

                        this._router.navigate(['/login']);

                      }

                    })

                  } else {
                    this.can_edit = true;
                  }
                }
              })



            } else {
              toastr.error('Category Type Not Found  !', '', { timeOut: 3000 });
              this._router.navigate(['/login']);

            }
          });

        } else {
          toastr.error('Category List Not Found  !', '', { timeOut: 3000 });
          this._router.navigate(['/login']);

        }
      });


      this.articleService.getUserGroup(data).subscribe((res) => {

        if (res.status == 'success') {


          this.departmentList = res.department;

        } else {
          this.toastr.error(res.message, '', { timeOut: 5000 });
        }
      });





    } catch (exec) {
      toastr.error('Category List Not Found  !', '', { timeOut: 3000 });

      this._router.navigate(['/login']);


    }

    this.msgSubscription = this.msg.getMessage().subscribe((e) => {

      if (e != undefined) {

        switch (e.text.type) {

          case 'copyArticle':


            // this.copyArticleId=e.text.data.articleId
            let data2 = {
              token: this.token,
              id: e.text.data.articleId,
              'page': 'article'
            }

            this.articleService.articleData(data2).subscribe((response) => {

              if (response.status == 'success') {

                toastr.success('Article elements copied successfully!', '', { timeOut: 3000 });

                // this.articleRecord= response.article[0];

                this.loginUser = response.user;

                // this.permissions = (response.permission !=undefined || response.permission!=null)? response.permission:[];

                //  this.can_edit =  (this.check_permission_admin(this.articleRecord,this.loginUser) ||  this.check_permission_publisher(this.articleRecord,this.loginUser) || this.check_permission_author(this.articleRecord,this.loginUser) || this.check_permission_reviewer(this.articleRecord,this.loginUser) || this.check_permission_coauthor(this.articleRecord,this.loginUser));


                // if(!this.can_edit){

                //   toastr.error(' You dont have the permission to edit the article  !', '', {timeOut: 3000});

                //   this._router.navigate(['/article']);


                // }

                this.copyArticleId = response.article[0].title;

                if (e.text.data.title == true) {
                  this.tittle = response.article[0].title;
                  $('.article_title').addClass('value-exists');
                } else {
                  this.tittle = ''
                  $('.article_title').removeClass('value-exists');
                }

                if (e.text.data.short == true) {
                  this.htmlDescription = response.article[0].summary;
                } else {
                  this.htmlDescription = ''
                }

                if (e.text.data.body == true) {
                  this.htmlContent = response.article[0].content;

                  this.prevhtmlContent = this.domSanitizer.bypassSecurityTrustHtml(response.article[0].content);
                } else {
                  this.htmlContent = ''
                }

                if (e.text.data.header == true) {
                  let name = (response.article[0].mainimage != undefined && response.article[0].mainimage != '') ? response.article[0].mainimage.split('/') : [];
                  this.headerImage = response.article[0].mainimage;
                  this.headerImageName = (name.length > 0) ? name[2] : '';
                } else {
                  this.headerImage = ''
                  this.headerImageName = '';
                }

                if (e.text.data.thumb == true) {
                  let tname = (response.article[0].thumbimage != undefined && response.article[0].thumbimage != '') ? response.article[0].thumbimage.split('/') : [];

                  this.thumbImage = response.article[0].thumbimage;
                  this.thumbImageName = (tname.length > 0) ? tname[2] : '';
                } else {
                  this.thumbImage = ''
                  this.thumbImageName = '';
                }

                if (e.text.data.thumb == true) {
                  let tags = []
                  response.article[0].tag.map((x) => {
                    let data = {}
                    data['name'] = x
                    data['isEdit'] = false
                    tags.push(data)
                  })

                  this.tags = response.article[0].tag;
                } else {
                  this.tags = []
                }

              } else {

                toastr.error('Article Not Found  !', '', { timeOut: 3000 });

                this._router.navigate(['/login']);

              }

            })


            break;
        }

      }

    })

  }



  viewImageinModal(url, thumbImage, val) {
    console.log("url====", url);
    console.log("thumbImage====", thumbImage);
    console.log("val====", val);

    if (val == 1) {
      this.classval = 'modal fade addnew-popup invite_popup headerpop'
    } else {
      this.classval = 'modal fade addnew-popup invite_popup thumbpop'
    }
    if (thumbImage.includes("mitsubishi-motors")) {
      this.fileUrl = thumbImage;
    } else {
      this.fileUrl = url + thumbImage;
    }



    $('#preview_image_now').modal('show');


  }


  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded() {
    // show cropper

  }

  cropperReady() {
    // cropper ready 771, 205.6
    this.imageCropper.cropper = { x1: 0, y1: 0, x2: 800, y2: 200 };

  }

  close_profile_image_modal() {


    $('#profile_image_modal').modal('hide');


    this.processFiles(this.croppedImage, 'header');


  }

  close_profile_image_th_modal() {


    $('#profile_image_th_modal').modal('hide');


    this.processFiles(this.croppedImage_th, 'thumb');


  }


  loadImageFailed() {
    // show message

  }



  imageCropped_th(event: ImageCroppedEvent) {
    this.croppedImage_th = event.base64;
  }
  imageLoaded_th() {
    // show cropper

  }

  cropperReady_th() {
    // cropper ready
    this.imageCropper_th.cropper = { x1: 0, y1: 0, x2: 420, y2: 420 };

  }


  loadImageFailed_th() {
    // show message

  }







  check_permission_author(article, user) {


    if (article != undefined) {

      let author = (article.author != undefined) ? article.author : [];

      // return (article.status =='Draft' || article.status =='Rejected') && ( article.history.createdId == user.id || ((author.join().indexOf(user.id) >= 0)?true:false))
      let ispermission = false

      author.map((x) => {
        if (x == user.id) {
          ispermission = true
        }
      })

      //  return (article.status =='Draft' || article.status =='Rejected') && ( article.history.createdId == user.id || ((author.join().indexOf(user.id) >= 0)?true:false))
      return (article.status == 'Draft' || article.status == 'Rejected') && (article.history.createdId == user.id || ispermission)

    }

  }


  check_permission_reviewer(article, user) {

    if (article != undefined) {

      let approver = (article.approver != undefined) ? article.approver : [];

      //  return (article.status =='Pending' || article.status =='Rejected') && (approver.includes(user.id))

      // return (article.status =='Pending' || article.status =='Rejected') && ((approver.join().indexOf(user.id) >= 0)?true:false)
      let ispermission = false

      approver.map((x) => {
        if (x == user.id) {
          ispermission = true
        }
      })

      return (article.status == 'Pending' || article.status == 'Rejected') && ispermission
    }

  }

  check_permission_coauthor(article, user) {

    if (article != undefined) {

      let coauthor = (article.coauthor != undefined) ? article.coauthor : [];

      //  return (article.status =='Pending' || article.status =='Rejected') && (approver.includes(user.id))

      // return (article.status =='Draft' || article.status =='Rejected') && ((coauthor.join().indexOf(user.id) >= 0)?true:false)
      let ispermission = false

      coauthor.map((x) => {
        if (x == user.id) {
          ispermission = true
        }
      })
      return (article.status == 'Draft' || article.status == 'Rejected') && ispermission
    }

  }

  check_permission_admin(record, user) {



    //  return  this.permissions.includes('manage_article') ;

    return (this.permissions.join().indexOf('manage_article') >= 0) ? true : false
  }

  check_permission_publisher(article, user) {

    if (article != undefined) {

      let publisher = (article.publisher != undefined) ? article.publisher : [];


      let ispermission = false

      publisher.map((x) => {
        if (x == user.id) {
          ispermission = true
        }
      })

      // return  (article.status =='Unpublished' || article.status =='Approved' || article.status =='Published' || article.status =='Rejected' ) && publisher.includes(user.id) ;


      // return  (article.status =='Unpublished' || article.status =='Approved' || article.status =='Published' || article.status =='Rejected' ) && (( publisher.join().indexOf(user.id) >= 0)?true:false);

      //ranjit 11.07.2022

      return (article.status == 'Unpublished' || article.status == 'Approved' || article.status == 'Published' || article.status == 'Rejected') && ispermission;
    }

  }



  approvePopup() {

    $('#approve-popup').modal('show');

  }

  countryPopup() {
    $('#country-popup').modal('show');
  }

  statusText() {


    switch (this.selectedPendingStatus) {


      case 'Update':

        $('#modal-backdrop').removeClass('show');
        $('#approve-popup').modal('hide');

        this.createArticle(2);


        break;

      case 'SendBack':

        $('#modal-backdrop').removeClass('show');
        $('#approve-popup').modal('hide');

        this.createArticle(9);


        break;

      case 'UnPublish':

        $('#modal-backdrop').removeClass('show');
        $('#approve-popup').modal('hide');

        this.createArticle(6);


        //     this.articleService.articleStatus({'token':this.token,'reqData':{article:this.articleId,comment:this.textstatus,unpublish:true}}).subscribe( (e)=>{

        //     this.textstatus='';

        //     if(e.status=='success'){


        //     // $('#modal-backdrop').removeClass('show');

        //     this.toastr.success('Article is unpublished !', '', {timeOut: 3000});


        //      $('#approve-popup').modal('hide');


        //      this._router.navigate(['/article']);



        //     }

        //  });


        break;

      case 'Publish':

        $('#modal-backdrop').removeClass('show');
        $('#approve-popup').modal('hide');

        this.createArticle(5);



        //     this.articleService.articleStatus({'token':this.token,'reqData':{article:this.articleId,comment:this.textstatus,publish:true}}).subscribe( (e)=>{

        //     this.textstatus='';

        //     if(e.status=='success'){


        //     // $('#modal-backdrop').removeClass('show');

        //     this.toastr.success('Article is published !', '', {timeOut: 3000});


        //      $('#approve-popup').modal('hide');


        //      this._router.navigate(['/article']);



        //     }

        //  });


        break;



      case 'Approve':

        $('#modal-backdrop').removeClass('show');
        $('#approve-popup').modal('hide');


        this.createArticle(3);


        //    this.articleService.articleStatus({'token':this.token,'reqData':{article:this.articleId,comment:this.textstatus,approve:true}}).subscribe( (e)=>{

        //    this.textstatus='';

        //    if(e.status=='success'){


        //    // $('#modal-backdrop').removeClass('show');

        //    this.toastr.success('Article is approved !', '', {timeOut: 3000});


        //     $('#approve-popup').modal('hide');


        //     this._router.navigate(['/article']);



        //    }

        // });


        break;

      case 'Reject':


        $('#modal-backdrop').removeClass('show');
        $('#approve-popup').modal('hide');

        this.createArticle(4);


        //   this.articleService.articleStatus({'token':this.token,'reqData':{article:this.articleId,comment:this.textstatus,reject:true}}).subscribe( (e)=>{

        //     this.textstatus='';

        //     if(e.status=='success'){


        //       this.toastr.success('Article is rejected !', '', {timeOut: 3000});

        //      // $('#modal-backdrop').removeClass('show');
        //      $('#approve-popup').modal('hide');


        //      this._router.navigate(['/article']);


        //     }

        //  });

        break;





    }

  }


  reviewerAdded($event) {





    //   let selected_reviewers =this.reviewers.filter(singleItem => singleItem.selected == true);

    //  // console.log(selected_reviewers);

    //   this.list_emails =[];

    //   selected_reviewers.forEach(element => {

    //     this.list_emails.push(element.email);

    //   });


    //   console.log(selected_reviewers);


  }

  isDisabled() {

    if (this.reviewers.length > 0) {

      let selected_reviewers = this.reviewers.filter(singleItem => singleItem.selected == true);

      this.list_emails = [];

      this.approvers_id = [];

      selected_reviewers.forEach(element => {

        this.list_emails.push(element.email);
        this.approvers_id.push(element.id);

      });



      return this.list_emails.length == 0;

    } else if (this.publishers.length > 0) {


      let selected_publishers = this.publishers.filter(singleItem => singleItem.selected == true);

      this.list_emails = [];

      this.publishers_id = [];


      selected_publishers.forEach(element => {

        this.list_emails.push(element.email);
        this.publishers_id.push(element.id);


      });

      return this.list_emails.length == 0;

    } else if (this.authors.length > 0) {


      let selected_authors = this.authors.filter(singleItem => singleItem.selected == true);

      this.list_emails = [];

      this.shares_id = [];


      selected_authors.forEach(element => {

        this.list_emails.push(element.email);
        this.shares_id.push(element.id);


      });

      return this.list_emails.length == 0;


    } else if (this.delegates.length > 0) {


      let selected_delegates = this.delegates.filter(singleItem => singleItem.selected == true);

      this.list_emails = [];

      this.delegates_id = [];

      selected_delegates.forEach(element => {

        this.list_emails.push(element.email);
        this.delegates_id.push(element.id);


      });

      return this.list_emails.length == 0;

    }


  }



  sendForReview() {


    $('#review-popup').modal('hide');

    if (this.reviewers.length > 0) {

      this.createArticle(1);

    } else if (this.publishers.length > 0) {

      this.createArticle(3);

    } else if (this.authors.length > 0) {
      this.createArticle(7);
    } else if (this.delegates.length > 0) {
      this.createArticle(8);
    }


  }

  sendForCountry() {
    $('#country-popup').modal('hide');
    this.createArticle(10);
  }

  broadcast_menu() {


    this.msg.sendMessage({ 'user': this.userName, 'notification': this.notification, 'type': 'left_menu_link', 'navigations': this.navigationsType });


  }

  ngOnDestroy() {

    this.msgSubscription.unsubscribe();

  }

  setup(ed) {

    var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys

    ed.on('keydown', function (e) {

      if (allowedKeys.indexOf(e.keyCode) != -1) return true;

      if ((this.htmlDescription).replace(/<[^>]*>/g, '').length + 1 > this.max_count) {

        if ((this.htmlDescription).replace(/<[^>]*>/g, '').length - this.max_count > 1) {

          this.htmlDescription = (this.htmlDescription).replace(/<[^>]*>/g, '').substring(0, this.max_count);

          this.htmlDescription = this.commonService.getHtmlforPresent(this.htmlDescription);

        }

        return false;
      }

      return true;


    }.bind(this));



    ed.on('keyup', function (e) {

      if (allowedKeys.indexOf(e.keyCode) != -1) return true;

      if ((this.htmlDescription).replace(/<[^>]*>/g, '').length + 1 > this.max_count) {

        if ((this.htmlDescription).replace(/<[^>]*>/g, '').length - this.max_count > 1) {

          this.htmlDescription = (this.htmlDescription).replace(/<[^>]*>/g, '').substring(0, this.max_count);

          this.htmlDescription = this.commonService.getHtmlforPresent(this.htmlDescription);
        }

        return false;
      }

      return true;

    }.bind(this));


  }


  images_upload_handler(blobInfo, success, failure) {

    var xhr, formData;

    xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    let url = AppSettings.API_ENDPOINT + 'upload.php';

    xhr.open('POST', url);

    xhr.onload = function () {
      var json;

      if (xhr.status != 200) {
        failure('HTTP Error: ' + xhr.status);
        return;
      }

      json = JSON.parse(xhr.responseText);

      // if (!json || typeof json.location != 'string') {
      //   failure('Invalid JSON: ' + xhr.responseText);
      //   return;
      // }


      if (json.status == "error") {
        failure('File upload failed.');
        return;
      }

      success(AppSettings.API_ENDPOINT + json.files[0].path);
    };

    formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());

    xhr.send(formData);
  }

  onItemSelect(item: any) {
    this.categoryError = '';
  }
  onSelectAll(items: any) {
    this.categoryError = '';
  }
  onTypeSelect(item: any) {
    if (item.key == "main_story") {
      this.max_count = 250;
      this.min_count = 200;
    } else {
      this.max_count = 150;
      this.min_count = 100;
    }
    this.categoryTypeError = '';
  }

  onNewsletterSelect(item: any) {
    this.newsletterError = '';
  }

  onNewsletterDeSelect(item: any) {

    this.selectedNewsletter = []

  }

  onTypeDeSelect(event: any) {

    this.selectedCategoryType = ''

  }

  onCategoryDeSelect(event: any) {

  }

  onDeSelectAll(event: any) {

    this.selectedCategoryList = []
  }

  create_tags(tag_name: string) {

    if (this.tags.findIndex((tag) => { return tag == tag_name; }) == -1) {

      this.tags.push(tag_name);
      this.create_tag = '';
    }


  }

  remove_tag(index: number) {

    this.tags.splice(index, 1);

  }

  titleCase(str) {
    if (str != null) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {

        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }

      return splitStr.join(' ');
    }

  }
  openFileUploader(option) {
    this.fileUploadType = option;
    window.open(this.fileUploadUrl + 'documents?type=Files+%26+Folders&select_document=true');
  }

  ngOnInit() {


    //  editor setting
    this.init = {
      base_url: '/assets',
      nowrap: false,
      importcss_append: true,
      content_css: ['/assets/css/screen.css', '/assets/css/developer.css?v=20260916'],
      menubar: false,
      statusbar: false,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks fullscreen',
        'insertdatetime table paste help wordcount media'
      ],
      extended_valid_elements: 'iframe[src|frameborder|style|scrolling|class|width|height|name|align]',
      image_advtab: true,
      images_upload_handler: this.images_upload_handler,
      toolbar: 'insertfile undo redo| alignleft aligncenter alignright alignjustify | bold italic underline| bullist numlist | image link media | forecolor backcolor | copy mypaste | table styleselect',
      color_map: [
        '000000', 'Black',
        'FFFFFF', 'White',
        'ED0000', 'Red'

      ],
      custom_colors: false,
      setup: function (editor) {
        editor.ui.registry.addButton('mypaste', {
          tooltip: 'Paste',
          icon: 'paste',
          onAction: () => {
            let html = localStorage.getItem('contentcopy')
            if (html != undefined) {
              editor.setContent('')
              editor.insertContent(html);
            }

          },


        });

      },
      style_formats: [
        { title: 'Header styles' },
        { title: 'Article Grey Header', block: 'p', classes: 'header1' },
        { title: 'Table styles' },
        { title: 'Full Border Table', selector: 'table', classes: 'table1' },
        { title: 'No Border Table', selector: 'table', classes: 'table2' },
        { title: 'Header Black Table', selector: 'table', classes: 'table3' }
        // {title: 'Table with black capital header', selector: 'table', classes: 'table4'}
      ],
      content_style: '.table1 {width:100%;border:1px solid #000;}' +
        '.table1 tr:not(:last-child) td {border-bottom:1px solid #000;}' +
        '.table1 td:not(:last-child) {border-right:1px solid #000;}' +
        '.table1 td {padding:15px;}' + '.table1 td:first-child {width:70%;}' +
        '.table2 {width:100%;border:1px dashed #ccc;}' +
        '.table2 tr:not(:last-child) td {border-bottom:1px dashed #ccc;}' +
        '.table2 td:not(:last-child) {border-right:1px dashed #ccc;}' +
        '.table2 td {padding:15px;}' +
        '.table2 td:first-child {width:40%;font-weight:900;}' +
        '.table3 {width:100%;border:1px solid #666;}' +
        '.table3 tr:not(:last-child) td {border-bottom:1px solid #666;}' +
        '.table3 td:not(:last-child) {border-right:1px solid #666;}' +
        '.table3 td {padding:10px;}' +
        '.table3 th {padding:10px;}' +
        '.table3 tr:first-child td {background-color:#000;font-weight:900;color:#fff;text-transform:capitalize;}' +
        '.table3 th {background-color:#000;font-weight:900;color:#fff;text-transform:capitalize;}' +
        '.table4 {width:100%;border:1px solid #666;}' +
        '.table4 tr:not(:last-child) td {border-bottom:1px solid #666;}' +
        '.table4 td:not(:last-child) {border-right:1px solid #666;}' +
        '.table4 td {padding:10px;}' +
        '.table4 th {padding:10px;}' +
        '.table4 th {background-color:#000;font-weight:900;color:#fff;text-transform:uppercase;}' +
        '.table4 tr:first-child td {background-color:#000;font-weight:900;color:#fff;text-transform:uppercase;}' +
        '.header1 {font-size: 20px !important; padding: 10px 15px; text-transform: uppercase; font-weight: bold; background-image: linear-gradient(to right, #eee, rgba(255,255,255,0));}'



    }

    this.init2 = {
      base_url: '/assets',
      nowrap: false,
      importcss_append: true,
      content_css: ['/assets/css/screen.css', '/assets/css/developer.css?v=20260916'],
      menubar: false,
      statusbar: false,
      plugins: [
        'advlist autolink lists link image charmap print preview anchor',
        'searchreplace visualblocks fullscreen',
        'insertdatetime table paste help wordcount media'
      ],
      extended_valid_elements: 'iframe[src|frameborder|style|scrolling|class|width|height|name|align]',
      image_advtab: true,
      images_upload_handler: this.images_upload_handler,
      toolbar: 'insertfile undo redo| alignleft aligncenter alignright alignjustify | bold italic underline| bullist numlist | image link media | forecolor backcolor | copy mypaste | table styleselect',
      color_map: [
        '000000', 'Black',
        'FFFFFF', 'White',
        'ED0000', 'Red'

      ],
      custom_colors: false,
      setup: function (editor) {
        editor.ui.registry.addButton('mypaste', {
          tooltip: 'Paste',
          icon: 'paste',
          onAction: () => {
            let html = localStorage.getItem('contentcopy')
            if (html != undefined) {
              editor.setContent('')
              editor.insertContent(html);
            }

          },


        });

      },
      style_formats: [
        { title: 'Header styles' },
        { title: 'Article Grey Header', block: 'p', classes: 'header1' },
        { title: 'Table styles' },
        { title: 'Full Border Table', selector: 'table', classes: 'table1' },
        { title: 'No Border Table', selector: 'table', classes: 'table2' },
        { title: 'Header Black Table', selector: 'table', classes: 'table3' }
        // {title: 'Table with black capital header', selector: 'table', classes: 'table4'}
      ],
      content_style: '.table1 {width:100%;border:1px solid #000;}' +
        '.table1 tr:not(:last-child) td {border-bottom:1px solid #000;}' +
        '.table1 td:not(:last-child) {border-right:1px solid #000;}' +
        '.table1 td {padding:15px;}' + '.table1 td:first-child {width:70%;}' +
        '.table2 {width:100%;border:1px dashed #ccc;}' +
        '.table2 tr:not(:last-child) td {border-bottom:1px dashed #ccc;}' +
        '.table2 td:not(:last-child) {border-right:1px dashed #ccc;}' +
        '.table2 td {padding:15px;}' +
        '.table2 td:first-child {width:40%;font-weight:900;}' +
        '.table3 {width:100%;border:1px solid #666;}' +
        '.table3 tr:not(:last-child) td {border-bottom:1px solid #666;}' +
        '.table3 td:not(:last-child) {border-right:1px solid #666;}' +
        '.table3 td {padding:10px;}' +
        '.table3 th {padding:10px;}' +
        '.table3 tr:first-child td {background-color:#000;font-weight:900;color:#fff;text-transform:capitalize;}' +
        '.table3 th {background-color:#000;font-weight:900;color:#fff;text-transform:capitalize;}' +
        '.table4 {width:100%;border:1px solid #666;}' +
        '.table4 tr:not(:last-child) td {border-bottom:1px solid #666;}' +
        '.table4 td:not(:last-child) {border-right:1px solid #666;}' +
        '.table4 td {padding:10px;}' +
        '.table4 th {padding:10px;}' +
        '.table4 th {background-color:#000;font-weight:900;color:#fff;text-transform:uppercase;}' +
        '.table4 tr:first-child td {background-color:#000;font-weight:900;color:#fff;text-transform:uppercase;}' +
        '.header1 {font-size: 20px !important; padding: 10px 15px; text-transform: uppercase; font-weight: bold; background-image: linear-gradient(to right, #eee, rgba(255,255,255,0));}'



    }

    window.scrollTo(0, 0);

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
    this.dropdownSettings2 = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };
    this.dropdownSettings3 = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 4,
      allowSearchFilter: true
    };

    let arr = []
    this.country.map((x) => {
      let obj = {}
      obj['key'] = x.key.toUpperCase()
      obj['value'] = x.value
      arr.push(obj)
    })
    this.countryList = arr

    let tokenA: any = (localStorage.getItem('token') != undefined) ? atob(localStorage.getItem('token')) : 0;

    if (!tokenA) throw 'Error in parse';

    if (!JSON.parse(tokenA)) throw 'Error in json parse';

    tokenA = JSON.parse(tokenA);


    this.token = tokenA.token;


    let data = {
      token: tokenA.token,
      limit: 20,
      'page': 'settings'
    }

    this.articleService.getCountryGroup(data).subscribe((res) => {

      if (res.status == 'success') {
        this.countryGroup = res.groups
        this.countryGroup.map((x) => {
          x['label'] = x.group
          x['value'] = x.group
          x['isChecked'] = false
        })

      }

    })
  }

  ngAfterViewInit() {

    $(document).ready(function () {

      window.scrollTo(0, 0);

      // console.log(this.tittle);


      if (this.tittle != '') {

        $('.article_title').addClass('value-exists');

      }

      if (this.subTittle != '') {

        $('.article_subtitle').addClass('value-exists');

      }





      $('#br1').on('click', function (e) {



      });


      $('#divtags').on('click', function (e) {

        //  $('#tags').focus();

      });

      $('[data-toggle="tooltip"]').tooltip();
      $('input').blur(function (event) {
        var inputValue = this.value;
        if (inputValue) {
          this.classList.add('value-exists');
        } else {
          this.classList.remove('value-exists');
        }
      });

    }.bind(this));

  }

  onCountrySelect($event) {

  }

  onCountrySelectAll($event) {

  }

  onCountryDeSelect($event) {

  }

  onCountryDeSelectAll($event) {

  }

  createObjectURL() {
    if (window.URL) {
      return window.URL;
    } else {
      return null;
    }
  }


  onInputClick($event) {

    $event.target.value = ''
  }

  uploadHeaderImage($event) {



    let _URL: any = '';

    _URL = this.createObjectURL();



    let img = new Image();

    img.onload = function () {



      let width = img.naturalWidth || img.width;
      let height = img.naturalHeight || img.height;

      let aspect = parseFloat((width / height).toFixed(2));



      if (width < 1224 && !$event.target.files[0].type.match(/(\.jpg|\.png|\.JPG|\.PNG|\.jpeg|\.JPEG|\.gif|\.GIF)$/)) {


        this.toastr.error(' Please upload image  with mentioned resolution', '', { timeOut: 3000 });


      }
      else if ($event.target.files[0].size > 10485760) {

        this.toastr.error(' Please upload image  with mentioned size', '', { timeOut: 3000 });


      }
      else {



        // console.log(this.main_img);



        this.imageChangedEvent = $event;


        $('#profile_image_modal').modal('show');



        // this.processFiles($event.target.files[0],'header');





      }
      // else if(  aspect <3.7 || aspect >3.8){

      //   this.toastr.error(' Please upload image  with mentioned resolution', '', {timeOut: 3000});

      // }






    }.bind(this);

    img.src = _URL.createObjectURL($event.target.files[0]);

    //this.processFiles($event.target.files[0],'header');
  }






  drop($event: any) {

    $event.stopPropagation();
    $event.preventDefault();

    let _URL: any = '';



    _URL = this.createObjectURL();



    let img = new Image();

    img.onload = function () {


      let width = img.naturalWidth || img.width;
      let height = img.naturalHeight || img.height;

      let aspect = parseFloat((width / height).toFixed(2));





      // if(width <1400 || height <370 ){

      if (width < 1224 && !this.main_img.type.match(/(\.jpg|\.png|\.JPG|\.PNG|\.jpeg|\.JPEG|\.gif|\.GIF)$/)) {


        this.toastr.error(' Please upload image  with mentioned resolution', '', { timeOut: 3000 });


      }
      else if (this.main_img.size > 10485760) {

        this.toastr.error(' Please upload image  with mentioned size', '', { timeOut: 3000 });


      }
      else {



        this.imageChangedEvent = { target: { files: [this.main_img] } }



        $('#profile_image_modal').modal('show');




        // this.processFiles(this.main_img,'header');



      }
      // else if(aspect <=3.5 && aspect >= 3.78 ){

      //   this.toastr.error(' Please upload image  with mentioned resolution', '', {timeOut: 3000});

      // }



    }.bind(this);



    this.main_img = $event.dataTransfer.files[0]

    img.src = _URL.createObjectURL($event.dataTransfer.files[0]);

  }

  onInputClick2($event) {

    $event.target.value = ''
  }


  uploadThumbImage($event) {




    let _URL: any = '';



    _URL = this.createObjectURL();



    let img = new Image();

    img.onload = function () {

      let width = img.naturalWidth || img.width;
      let height = img.naturalHeight || img.height;



      let aspect = parseFloat((width / height).toFixed(2));


      if (width < 420 && !$event.target.files[0].type.match(/(\.jpg|\.png|\.JPG|\.PNG|\.jpeg|\.JPEG|\.gif|\.GIF)$/)) {


        this.toastr.error(' Please upload image  with mentioned resolution', '', { timeOut: 3000 });


        // }else if( aspect != 1 ){

        //   this.toastr.error('Please upload image  with mentioned resolution', '', {timeOut: 3000});

      }
      else if ($event.target.files[0].size > 10485760) {

        this.toastr.error(' Please upload image  with mentioned size', '', { timeOut: 3000 });

      }
      else {


        this.imageChangedEvent_th = $event;

        $('#profile_image_th_modal').modal('show');


        //this.processFiles($event.target.files[0],'header');

        //this.processFiles($event.target.files[0],'thumb');




      }





    }.bind(this);

    img.src = _URL.createObjectURL($event.target.files[0]);



  }

  dropv2($event: any) {

    $event.stopPropagation();
    $event.preventDefault();



    let _URL: any = '';



    _URL = this.createObjectURL();



    let img = new Image();

    img.onload = function () {

      //console.log(this.thumb_img);

      let width = img.naturalWidth || img.width;
      let height = img.naturalHeight || img.height;



      let aspect = parseFloat((width / height).toFixed(2));


      if (width < 420 && !this.thumb_img.type.match(/(\.jpg|\.png|\.JPG|\.PNG|\.jpeg|\.JPEG|\.gif|\.GIF)$/)) {


        this.toastr.error(' Please upload image  with mentioned resolution', '', { timeOut: 3000 });


      }
      else if (this.thumb_img.size > 10485760) {

        this.toastr.error('Please upload image  with mentioned size', '', { timeOut: 3000 });

      }
      else {


        //this.processFiles($event.target.files[0],'header');

        this.imageChangedEvent_th = { target: { files: [this.thumb_img] } }



        $('#profile_image_th_modal').modal('show');



        // this.processFiles(this.thumb_img,'thumb');

      }



    }.bind(this);

    //console.log('fgfgf',$event.dataTransfer.files[0])

    this.thumb_img = $event.dataTransfer.files[0];

    img.src = _URL.createObjectURL($event.dataTransfer.files[0]);

  }

  allowDrop(e: any) {

    e.stopPropagation();
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';

  }

  //image upload
  processFiles(file, imageLocation) {

    try {


      let res: any = file;

      let token: any = JSON.parse(atob(localStorage.getItem('token')));

      var data = new FormData();

      data.append('upload[0][content]', res);

      let time = new Date().getTime();

      data.append('upload[0][name]', imageLocation + '_' + time);

      let obj = {
        token: token,
        reqData: data
      }

      this.newsService.imageUpload(obj).subscribe((res) => {
        // console.log('ffffkkkkkkkk',res)

        if (res.status == 'success') {

          let name = res.files[0].path.split('/')


          if (imageLocation == 'header') {

            this.headerImage = res.files[0].path
            this.headerImageName = name[2]
            this.mainImageError = ''

          } else {
            this.thumbImage = res.files[0].path
            this.thumbImageName = name[2]
            this.thumImageError = ''
          }

        }

      });

    } catch (e) {

      this.toastr.error('File upload failed!', '', { timeOut: 3000 });
    }


    // if(file){

    //   if (!file.type.match(/(\.jpg|\.png|\.JPG|\.PNG|\.jpeg|\.JPEG|\.gif|\.GIF)$/) && file.size < 10485760) {

    //     var data = new FormData();
    //     var upload =[];
    //     data.append('file', file);

    //     try{
    //       let token: any = JSON.parse(atob(localStorage.getItem('token')));
    //       let obj = {
    //           token: token,
    //           reqData: data
    //       }
    //       this.newsService.imageUpload(obj).subscribe((res) => {

    //               if (res.status == 'success') {
    //                 let name=res.files[0].path.split('/')

    //                 if(imageLocation == 'header'){
    //                   this.headerImage = res.files[0].path
    //                   this.headerImageName = name[2]
    //                   this.mainImageError=''
    //                 }else{
    //                   this.thumbImage = res.files[0].path
    //                   this.thumbImageName = name[2]
    //                   this.thumImageError=''
    //                 }


    //               } else {

    //               }

    //       })
    //     }catch(exec){
    //       this.toastr.error('File upload failed!', '', {timeOut: 3000});
    //     }


    //   } else {
    //     this.toastr.error('File upload failed!', '', {timeOut: 3000});
    //   }

    // }



  }//upload function end

  //file upload
  uploadAttachment($event) {


    this.processAttachment($event.target.files);
  }

  dropv3(e: any) {

    e.stopPropagation();
    e.preventDefault();

    this.processAttachment(e.dataTransfer.files);

  }

  processAttachment(files) {

    var formData = files;
    var data = new FormData(); //base64 or binary file
    var errorFlg = false;

    $.each(formData, function (i, file) {

      let ext = file.name.split('.').pop();


      if (ext == "pdf" || ext == "docx" || ext == "doc" || ext == "xlsx" || ext == "xls" || ext == "csv" || ext == "ppt" || ext == "pptx") {

        data.append('file'[i], file);

      } else {
        errorFlg = true;

      }


    });
    if (errorFlg) {
      this.toastr.error('Please upload a file of the supported types!', '', { timeOut: 3000 });
    }



    try {

      let token: any = JSON.parse(atob(localStorage.getItem('token')));
      let obj = {
        token: token,
        reqData: data
      }
      this.newsService.imageUpload(obj).subscribe((res) => {

        if (res.status == 'success') {
          // this.attachmentName=[]
          // this.attachment=[]
          res.files.map((x) => {
            let name = x.path.split('/');
            this.attachmentName.push(name[2])
            this.attachment.push(x.path)
            let toltip = name[2].split('_');
            toltip.shift();
            let arr = []

            toltip.map((y) => {
              arr.push(y)
            })

            this.toltipName.push(arr.join('_'))
          })
        } else {
          this.toastr.error('File upload failed!', '', { timeOut: 3000 });
        }

      })
    } catch (exec) {
      this.toastr.error('File upload failed!', '', { timeOut: 3000 });
    }
  }

  deleteThumb() {
    this.thumbImage = ''
    this.thumbImageName = ''
  }

  deleteHeader() {
    this.headerImage = ''
    this.headerImageName = ''
  }

  deleteAttachment(index) {
    this.attachmentName.splice(index, 1)
    this.attachment.splice(index, 1)
    this.toltipName.splice(index, 1)

  }
  deleteAttachmentGoTO(index) {
    this.attachmentNameGoTo.splice(index, 1)
    this.attachmentGoTO.splice(index, 1)
    this.toltipNameGoTo.splice(index, 1)

  }



  openZoomModal() {

    const modalRef1 = this.modalService.open(EditorZoom, { windowClass: "popup_fullwidth invite_popup" });
    modalRef1.componentInstance.content = this.htmlContent;

    modalRef1.componentInstance.passData.subscribe((receivedData) => {

      this.htmlContent = receivedData;
    })

  }


  reviewPopup(type) {

    let tt;

    if (type == 'author') {
      tt = 'author|reviewer|publisher'
    } else if (type == 'delegate') {
      tt = 'author|reviewer|publisher'
    } else if (type == 'reviewer') {
      tt = 'reviewer'
    } else if (type == 'publisher') {
      tt = 'publisher'
    }

    $('#review-popup').modal('show');


    let data = {
      token: this.token,
      user: tt
    }


    this.userService.getUserList(data).subscribe((response) => {

      if (response.status == 'success') {



        if (type == 'reviewer') {

          this.reviewers = (response.users != undefined) ? response.users : [];

          this.reviewers.forEach((element, i) => {

            this.reviewers[i].selected = false;
          });


          this.publishers = []
          this.authors = []
          this.delegates = []

        } else if (type == 'publisher') {

          this.publishers = (response.users != undefined) ? response.users : [];

          this.publishers.forEach((element, i) => {

            this.publishers[i].selected = false;
          });

          this.reviewers = []
          this.authors = []
          this.delegates = []

        } else if (type == 'author') {


          this.authors = (response.users != undefined) ? response.users : [];

          this.authors.forEach((element, i) => {

            this.authors[i].selected = false;
          });

          this.reviewers = []
          this.publishers = []
          this.delegates = []



        } else if (type == 'delegate') {


          this.delegates = (response.users != undefined) ? response.users : [];

          this.delegates.forEach((element, i) => {

            this.delegates[i].selected = false;
          });
          this.reviewers = []
          this.publishers = []
          this.authors = []

        }





      } else {


        this._router.navigate(['/login']);

      }

    });





  }

  changeDesp() {

    if (this.htmlDescription) {

      this.shortDescriptionError = '';

    }
  }

  changeContent() {

    if (this.htmlContent) {

      this.longDescriptionError = '';

      this.prevhtmlContent = this.domSanitizer.bypassSecurityTrustHtml(this.htmlContent);
    }
  }

  copy() {

    let xyz = this.htmlContent
    localStorage.setItem('contentcopy', xyz)
    this.toastr.success('Content copied successfully!', '', { timeOut: 3000 });
  }




  createArticle(reviewType) {

    //this.htmlDescription = this.commonService.getHtmlforPresent(this.htmlDescription);



    // this.headerImage;
    // this.thumbImage;
    // this.attachment;
    // this.tittle;
    // this.subTittle;
    // this.selectedCategoryList;
    // this.selectedCategoryType;
    // this.htmlContent;
    // this.htmlDescription;
    // this.tags;
    // this.create_tag;


    if (this.tittle == '') {

      this.titleError = 'Title is required';

      window.scrollTo(0, 0);

    }

    if (this.selectedCategoryList.length == 0) {

      this.categoryError = 'Please select article category';

      window.scrollTo(0, 0);

    }
    if (!this.selectedCategoryType) {

      this.categoryTypeError = 'Please select article type';

      window.scrollTo(0, 0);

    }

    if (!this.htmlDescription) {

      this.shortDescriptionError = 'Description is required!';

      window.scrollTo(0, 0);

    }

    if (!this.htmlContent) {

      this.longDescriptionError = 'Content is required!';
      window.scrollTo(0, 0);

    }

    // if(!this.department){

    //   this.departmentError='Set Publication/Author name is required!';
    //   window.scrollTo(0, 0);

    // }


    //shortDescriptionError:string;
    //  longDescriptionError :string;

    // if(this.selectedNewsletter.length==0){

    //   this.newsletterError='Please select newsletter';

    //   window.scrollTo(0, 0);

    // }

    //if(!this.headerImage){

    //  this.mainImageError='Header image is  required ';

    // }
    // if(!this.thumbImage){

    //  this.thumImageError='Thumb image is  required ';

    // }
    //&& (this.selectedNewsletter.length>0)

    if (this.tittle && (this.selectedCategoryList.length > 0) && this.selectedCategoryType && this.htmlContent && this.htmlDescription) {

      let finalJson = {}

      finalJson['title'] = this.tittle;
      if (this.subTittle) {
        finalJson['subtitle'] = this.subTittle;
      } else {
        finalJson['subtitle'] = '';
      }
      let categoryarr = []
      this.selectedCategoryList.map((x) => {
        categoryarr.push(x.key)
      })
      let typearr;
      this.selectedCategoryType.map((x) => {
        typearr = x.key
      })

      finalJson['category'] = categoryarr;
      finalJson['type'] = typearr;

      if (this.selectedNewsletter[0] != undefined) {
        finalJson['newsletter'] = this.selectedNewsletter[0].key;

      }

      var htmlString = this.htmlContent;
      var modifiedHTML;
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // Find all table elements within the temporary div
      var tables = tempDiv.querySelectorAll('table');

      if (tables.length > 0) {
        for (var i = 0; i < tables.length; i++) {
          var table = tables[i];

          var divElement = document.createElement('div');
          divElement.className = 'table-responsive';

          // Add the div element before the table
          table.parentNode.insertBefore(divElement, table);

          // Move the table inside the new div element
          divElement.appendChild(table);

          // Add the "table-article" class to the table element
          table.classList.add('table-article');
        }
        // Now, you can access the modified HTML
        modifiedHTML = tempDiv.innerHTML;
      } else {
        modifiedHTML = this.htmlContent;
      }

      // Create a new div element and add the "table-responsive" class


      console.log("modi==", modifiedHTML);

      finalJson['content'] = modifiedHTML;
      finalJson['summary'] = this.htmlDescription;
      finalJson['mainimage'] = this.headerImage;
      finalJson['thumbimage'] = this.thumbImage;


      if (this.attachment && this.attachmentGoTO) {
        finalJson['document'] = this.attachment.concat(this.attachmentGoTO);
      }
      else if (this.attachment) {
        finalJson['document'] = this.attachment
      } else if (this.attachmentGoTO) {
        finalJson['document'] = this.attachmentGoTO
      }
      else {
        finalJson['document'] = []
      }

      if (this.tags) {
        finalJson['tag'] = this.tags
      } else {
        finalJson['tag'] = []
      }


      if (this.articleId > 0) {
        finalJson['id'] = this.articleId
      }


      if (reviewType == 1) {


        $('#review-popup').modal('hide');


        finalJson['review'] = true;

        finalJson['approvers'] = this.list_emails;

        finalJson['approvers_id'] = this.approvers_id;

        finalJson['comment'] = this.comment;


      }


      if (reviewType == 2) {

        $('#approve-popup').modal('hide');

        finalJson['update'] = true;

        //  finalJson['approvers']=this.list_emails;

        // finalJson['approvers_id']=this.approvers_id;

        finalJson['comment'] = this.textstatus;

      }


      if (reviewType == 3) {

        $('#review-popup').modal('hide');


        finalJson['approve'] = true;

        finalJson['publishers'] = this.list_emails;

        finalJson['publishers_id'] = this.publishers_id;

        finalJson['comment'] = this.comment;

      }


      if (reviewType == 4) {

        $('#approve-popup').modal('hide');


        finalJson['reject'] = true;

        // finalJson['approvers']=this.list_emails;

        //  finalJson['approvers_id']=this.approvers_id;

        finalJson['comment'] = this.textstatus;

      }

      if (reviewType == 5) {

        $('#approve-popup').modal('hide');


        finalJson['publish'] = true;

        //  finalJson['approvers']=this.list_emails;

        //  finalJson['approvers_id']=this.approvers_id;

        finalJson['comment'] = this.textstatus;

      }

      if (reviewType == 6) {


        $('#approve-popup').modal('hide');


        finalJson['unpublish'] = true;

        // finalJson['approvers']=this.list_emails;

        //        finalJson['approvers_id']=this.approvers_id;

        finalJson['comment'] = this.textstatus;

      }

      if (reviewType == 7) {

        $('#review-popup').modal('hide');


        finalJson['share'] = true;

        finalJson['shares'] = this.list_emails;

        finalJson['shares_id'] = this.shares_id;

        finalJson['comment'] = this.comment;

      }
      if (reviewType == 8) {

        $('#review-popup').modal('hide');


        finalJson['delegate'] = true;

        finalJson['delegates'] = this.list_emails;

        finalJson['delegates_id'] = this.delegates_id;

        finalJson['comment'] = this.comment;

      }

      if (reviewType == 9) {

        $('#approve-popup').modal('hide');

        finalJson['sendback'] = true;

        //  finalJson['approvers']=this.list_emails;

        // finalJson['approvers_id']=this.approvers_id;

        finalJson['comment'] = this.textstatus;

      }


      if (reviewType == 10) {

        $('#country-popup').modal('hide');


      }

      let country = []

      this.selectedCountry.map((x) => {
        country.push(x.value)
      })

      finalJson['country'] = country;

      finalJson['page'] = 'article';

      if (this.checkedval == true) {
        finalJson['private'] = 1
      } else {
        finalJson['private'] = 0
      }

      if (this.checkedExternal == true) {
        finalJson['external'] = 1
      } else {
        finalJson['external'] = 0
      }
      finalJson['department'] = this.department

      if (this.copyArticleId) {
        finalJson['copy'] = this.copyArticleId
      }


      try {

        let tokenA: any = (localStorage.getItem('token') != undefined) ? atob(localStorage.getItem('token')) : 0;

        if (!tokenA) throw 'Error in parse';

        if (!JSON.parse(tokenA)) throw 'Error in json parse';

        tokenA = JSON.parse(tokenA);

        let data = {
          token: tokenA.token,
          reqData: finalJson,

        }



        this.articleService.createArticle(data).subscribe((res) => {

          if (res.status == 'success') {

            //  if(this.articleId >0 ){

            //   this.toastr.success('Article updated successfully!', '', {timeOut: 3000});


            //  }else{

            //   this.toastr.success('Article created successfully!', '', {timeOut: 3000});

            //  }

            if (finalJson['review'] != undefined && finalJson['review'] == true) {

              this.toastr.success('Article sent for review successfully!', '', { timeOut: 3000 });


            }
            else if (finalJson['update'] != undefined && finalJson['update'] == true) {

              this.toastr.success('Article updated successfully!', '', { timeOut: 3000 });


            }
            else if (finalJson['share'] != undefined && finalJson['share'] == true) {

              this.toastr.success('Article shared successfully!', '', { timeOut: 3000 });


            }
            else if (finalJson['delegate'] != undefined && finalJson['delegate'] == true) {

              this.toastr.success('Article delegated successfully!', '', { timeOut: 3000 });


            }
            else if (finalJson['sendback'] != undefined && finalJson['sendback'] == true) {

              this.toastr.success('Article send back to author successfully!', '', { timeOut: 3000 });


            }
            else if (finalJson['approve'] != undefined && finalJson['approve'] == true) {

              this.toastr.success('Article approved successfully!', '', { timeOut: 3000 });


            }
            else if (finalJson['publish'] != undefined && finalJson['publish'] == true) {

              this.toastr.success('Article published successfully!', '', { timeOut: 3000 });


            }
            else if (finalJson['unpublish'] != undefined && finalJson['unpublish'] == true) {

              this.toastr.success('Article unpublished successfully!', '', { timeOut: 3000 });


            }
            else if (finalJson['reject'] != undefined && finalJson['reject'] == true) {

              this.toastr.success('Article rejected successfully!', '', { timeOut: 3000 });


            }
            else {

              this.toastr.success('Article saved as draft successfully!', '', { timeOut: 3000 });

            }



            this._router.navigate(['/article']);

          } else {

            this.toastr.error('Article creation failed!', '', { timeOut: 3000 });
          }
        })


      } catch (exec) {
        this.toastr.error('Article creation failed!', '', { timeOut: 3000 });

      }


    }//if


  }

  onCheckChange(event) {

    this.checkedval == event

  }

  onExternalChange(event) {
    this.checkedExternal = event
  }

  get_category_type(type: string) {

    let typestr = this.articleCaregoryList.find((item) => { return item.key == type; });

    return (typestr != undefined) ? typestr.value : '';

  }

  titleCaseType(type: string) {

    let typestr = this.articleCaregoryType.find((item) => { return item.key == type; });

    return (typestr != undefined) ? typestr.value : '';

  }

  //tags name change
  onNameChange(evt: any, index) {

    this.tags[index] = evt

  }

  selectCheckBox(event, indx) {

    this.delegates.map((x, i) => {
      // if(i!=indx){ 
      //   x.selected=false
      // }
      x.selected = false
    })

    if (event.target.checked == true) {
      this.delegates[indx].selected = event.target.checked
    }

    return;

  }



  onChangeC(event: any) {

    this.selectedCountry = []
    const { checked, value } = event.target;
    let index = this.countryGroup.length;
    while (index--) {
      this.countryGroup[index].isChecked = value === this.countryGroup[index]['value'];
    }

    let country = []
    this.countryGroup.map((x) => {
      if (x.isChecked == true) {
        x.countries.map((x) => {
          let obj = {}
          obj['key'] = x.toUpperCase()
          obj['value'] = x
          country.push(obj)
        })
      }
    })
    this.selectedCountry = country


  }



}
